import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { computeListActionTypes, computeListLoadingAction, computeListLoadedAction, } from '../ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
//import { ComputeSearchList } from '../../../../models/ComputeSearchList';
import ComputeResource from '../../../Compute.resource';
const loadComputeListArgs = {
    filterOnType: computeListActionTypes.LOAD,
    loadResource: (payload, state) => {
        return ComputeResource.getComputeList(payload.workspaceId, payload.search);
    },
    loadingAction: computeListLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(computeListLoadedAction(payload, result));
    },
};
export const loadComputeEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadComputeListArgs);
export default combineEpics(loadComputeEpic);

//# sourceMappingURL=ComputeListEpic.js.map
